var render, staticRenderFns
import script from "./LInput.vue?vue&type=script&lang=js"
export * from "./LInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68102a71",
  null
  
)

export default component.exports